import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { aboutMe } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light text-black mb-6 tracking-tight">
            About Me
          </h2>
          <div className="w-24 h-0.5 bg-black mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Main Story */}
          <div className="space-y-8">
            <p className="text-lg leading-relaxed text-gray-700">
              {aboutMe.summary}
            </p>

            {/* Key Highlights */}
            <div>
              <h3 className="text-2xl font-light text-black mb-6">Key Achievements</h3>
              <div className="space-y-3">
                {aboutMe.highlights.map((highlight, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-black rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700 leading-relaxed">{highlight}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Education */}
          <div>
            <h3 className="text-2xl font-light text-black mb-6">Education</h3>
            <div className="space-y-4">
              {aboutMe.education.map((edu, index) => (
                <Card key={index} className="border-0 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <CardContent className="p-6">
                    <h4 className="font-medium text-black mb-2">{edu.degree}</h4>
                    <p className="text-gray-600 mb-2">{edu.school}</p>
                    {edu.year && (
                      <Badge variant="outline" className="text-xs">
                        {edu.year}
                      </Badge>
                    )}
                    {edu.status && (
                      <Badge variant="outline" className="text-xs ml-2">
                        {edu.status}
                      </Badge>
                    )}
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* Professional Recognition */}
            <div className="mt-12">
              <h4 className="text-xl font-light text-black mb-4">Professional Recognition</h4>
              <div className="grid grid-cols-1 gap-3">
                <div className="flex items-center space-x-3 p-3 bg-white rounded-lg">
                  <div className="w-3 h-3 bg-black rounded-full"></div>
                  <span className="text-gray-700">Chartered Engineer (COREN)</span>
                </div>
                <div className="flex items-center space-x-3 p-3 bg-white rounded-lg">
                  <div className="w-3 h-3 bg-black rounded-full"></div>
                  <span className="text-gray-700">Fellow - Nigerian Institution of Structural Engineers</span>
                </div>
                <div className="flex items-center space-x-3 p-3 bg-white rounded-lg">
                  <div className="w-3 h-3 bg-black rounded-full"></div>
                  <span className="text-gray-700">QGIS Expert & GEO University Lifetime Member</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;